import styled from 'styled-components'

export const InfoContainer2 = styled.div`
    color: #000;
    background: ${({lightBg}) => (lightBg ? '#f9f9f9' : '#ece7e7e2')};
    padding: 100px 0;
    margin-top: -81px;
`

export const InfoWrapper = styled.div`
    display: grid;
    z-index: 1;
    height; 860px;
    width: 100%;
    max-width: 1100px;
    margin-right: auto;
    margin-left: auto;
    padding: 0 24px;
    justify-content: center;
`

export const InfoRow = styled.div`
    display: grid;
    grid-auto-columns: minmax(auto, 1fr);
    align-items: center;
    grid-template-areas: ${({imgStart}) => (imgStart ? `'col2 col1'` : `'col1 col2'` )};

    @media screen and (max-width: 768px) {
        grid-template-areas: ${({imgStart}) => (imgStart ? `'col1' 'col2'` : `'col1 col1' 'col2 col2'`)}
    }
`

export const Column1 = styled.div`
    margin-bottom: 15px;
    padding: 0 15px;
    grid-area: col1;
`

export const Column2 = styled.div`
    margin-bottom: 15px;
    padding: 0 15px;
    grid-area: col2;
`
export const Column3 = styled.div`
    margin-bottom: 15px;
    grid-area: col1;
`

export const TextWrapper = styled.div`
    max-width: 540px;
    padding-top: 0;
    padding-bottom: 60px; 
    color: #000;
`
export const TextWrapper2 = styled.div`
    max-width: 540px;
    padding-top: 0;
    padding-bottom: 60px; 
    padding-left: 60px;

    @media screen and (max-width: 768px){
        padding-top: 50px;
        padding-right: 50px;
        align-items: center;
    }
`
export const TopLine = styled.p`
    color: #01bf71 !important;
    font-size: 16px;
    line-height: 16px;
    font-weight: 700;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    margin-bottom: 16px;
`
export const Heading = styled.h1`
    color: #000 !important;
    margin-bottom: 24px;
    font-size: 48px;
    line-height: 1.1;

    @media screen and (max-width: 480px){
        font-size: 32px;
    }
`
export const Heading2 = styled.h1`
    color: #000;
    margin-bottom: 24px;
    font-size: 48px;
    line-height: 1.1;

    @media screen and (max-width: 480px){
        font-size: 32px;
    }
`
export const Subtitle = styled.p`
    margin-right: 100px;
    max-width: 440px;
    margin-bottom: 15px;
    font-size: 18px;
    line-height: 24px;
    color: #000;

    @media screen and (max-width: 538px){
        margin-top: 50px;
        height: 250px;
        width: 300px;
    }
`
export const Subtitle2 = styled.p`
    margin-right: 100px;
    max-width: 440px;
    margin-bottom: 15px;
    font-size: 18px;
    line-height: 24px;
    color: #000;

    @media screen and (max-width: 538px){
        margin-top: -70px;
        height: 250px;
        width: 300px;
    }
`
export const Subtitle3 = styled.p`
    margin-right: 100px;
    max-width: 440px;
    margin-bottom: 15px;
    font-size: 18px;
    line-height: 24px;
    color: #000;

    @media screen and (max-width: 538px){
        margin-top: -20px;
        height: 250px;
        width: 300px;
    }
`
export const ImgWrap = styled.div`
    max-width: 555px;
    height: 100%;

    @media screen and (max-width: 538px){
        margin-top: -300px;
    }
`
export const Img = styled.img`
    width: 100%;
    height: 400px;
    margin: 0 0 10px 0;
    padding-right: 0;
    border-radius: 10px;

    @media screen and (max-width: 538px){
        height: 350px;
    }
`